import CustomTypography from "../Typography/CustomTypography";

export default function PaginationButton({
  page,
  current,
}: {
  page: number;
  current: number;
}) {
  return (
    <div
      className="text-black "
      style={{
        color: current === page ? "#fff" : "#000",
      }}
    >
      <CustomTypography
        as="span"
        weight={"light"}
        color={current === page ? "white" : "main"}
      >
        {page}
      </CustomTypography>
    </div>
  );
}
